export default "__VITE_ASSET__a27eb623__"